<script setup lang="ts">
import { ref, computed, onBeforeMount } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { baseUrl } from '@/core'
import { appServices } from '@/modules/app'
import VideoPlayer from '@/modules/app/components/base/VideoPlayer.vue'
import { useIdleTimeout } from '@/modules/app/composables/useIdleTimeout'

const router = useRouter()
const route = useRoute()

// Define Props ----------------------------------
const props = defineProps<{
  lang: string
}>()

// State -----------------------------------------
const dataId = ref(parseInt(route.params.id as string))
const video = ref<InstanceType<typeof VideoPlayer>>()
const videoSrc = computed(() => baseUrl($config.sermonVideos.find((e) => e.id == dataId.value).src))

// Getters ---------------------------------------

// Methods ---------------------------------------
function backToMain() {
  appServices.selectBackgroundMusic(dataId.value)
  router.push({ path: '/' })
}

// Events ----------------------------------------
onBeforeMount(() => {
  console.log('onBeforeMount', 'pauseBackgroundMusic()')
  appServices.pauseBackgroundMusic()
})

function onVideoPlay() {
  console.log('onVideoPlay')
  mainIdleTimeout.stop()
  videoIdleTimeout.stop()
}

function onVideoPause() {
  console.log('onVideoPause')
  videoIdleTimeout.start()
}

function onVideoEnded() {
  console.log('onVideoEnded')
  mainIdleTimeout.start()
  videoIdleTimeout.stop()
}

// Main Setup ------------------------------------
const mainIdleTimeout = useIdleTimeout('home', $config.discoveryIdleTimeoutToMainSeconds * 1000)
const videoIdleTimeout = useIdleTimeout('video', $config.discoveryIdleTimeoutToPlaySeconds * 1000)

mainIdleTimeout.onIdleTimeout(() => {
  backToMain()
})

videoIdleTimeout.onIdleTimeout(() => {
  video.value?.play()
})
// -----------------------------------------------
</script>

<template>
  <div :class="['sermon-content', `lang-${lang}`]">
    <img class="logo-small" :src="baseUrl(`/images/sermon/${lang}/logo-small.png`)" />
    <img class="title" :src="baseUrl(`/images/sermon/${lang}/title-${dataId}.png`)" />
    <!-- <div name="th" style="position: absolute; top:410px; left: 0; width: 600px; border: 1px solid yellow; opacity: .5;"></div> -->
    <!-- <div name="en" style="position: absolute; top:418px; left: 0; width: 600px; border: 1px solid yellow; opacity: .5;"></div> -->

    <div class="desc scrollbar">
      <img class="detail" :src="baseUrl(`/images/sermon/${lang}/desc-${dataId}.png`)" />
    </div>
    <img class="consonants" :src="baseUrl(`/images/sermon/${lang}/consonants.png`)" />
    <img class="back-to-main" :src="baseUrl(`/images/sermon/${lang}/back-to-main.gif`)" @click="backToMain" />
    <!-- <VideoPlayer
      :autoplay="videoAutoplay"
      :src="baseUrl(`/videos/video-desc-${dataId}.mp4`)"
    /> -->
    <VideoPlayer
      ref="video"
      :autoplay="true"
      :src="videoSrc"
      @ended="onVideoEnded"
      @pause="onVideoPause"
      @play="onVideoPlay"
    />
  </div>
</template>

<style scoped>
/* ------------------------ */
/* ------------------------ */
.sermon-content {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
/* ------------------------ */
.back-to-main {
  position: absolute;
  left: 36px;
  top: 967px;
  cursor: pointer;
}

.logo-small {
  position: absolute;
  left: 0;
  top: 0;
}

.title {
  position: absolute;
  left: 0;
  top: 220px;
}

.desc {
  position: absolute;
  left: 38px;
  top: 383px;
  width: 585px;
  height: 545px;
  overflow: auto;
  text-align: center;
}

.desc .detail {
  position: relative;
  margin: 0 auto;
}

.consonants {
  position: absolute;
  left: 646px;
  top: 712px;
}

:deep(.video-player) {
  left: 728px;
  top: 55px;
}

/* ------------------------ */
.lang-en .title {
  top: 230px;
}
.lang-en .desc {
  top: 390px;
  height: 565px;
}
/* ------------------------ */
</style>
